<script setup>
// A "Columns" button listing a table's optional columns with a check box
// each, like the shadcn data-table column toggle. v-model is the list of
// hidden column keys.
//   <UiColumnsMenu v-model="hidden" :columns="[{ key: 'notes', title: 'Notes' }]" />
defineProps({
  columns: { type: Array, required: true }, // [{ key, title }]
});
const hidden = defineModel({ type: Array, default: () => [] });

function toggle(key) {
  hidden.value = hidden.value.includes(key) ? hidden.value.filter((k) => k !== key) : [...hidden.value, key];
}
</script>

<template>
  <v-menu location="bottom end" :close-on-content-click="false">
    <template #activator="{ props: menu }">
      <v-btn v-bind="menu" variant="outlined" prepend-icon="mdi-view-column-outline" append-icon="mdi-chevron-down">
        Columns
      </v-btn>
    </template>
    <div class="ui-columns" role="group" aria-label="Show or hide columns">
      <div class="ui-columns__label">Show columns</div>
      <label v-for="col in columns" :key="col.key" class="ui-columns__item">
        <input type="checkbox" :checked="!hidden.includes(col.key)" @change="toggle(col.key)" />
        {{ col.title }}
      </label>
    </div>
  </v-menu>
</template>

<style scoped>
.ui-columns {
  min-width: 180px;
  padding: 4px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: 0 4px 12px -2px rgba(0, 0, 0, 0.08);
}
.ui-columns__label {
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 600;
  color: var(--muted-foreground);
}
.ui-columns__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 8px;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.ui-columns__item:hover {
  background: var(--accent);
}
.ui-columns__item input {
  accent-color: var(--foreground);
}
</style>
